(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c2s-cart-drawer"]) return;
  try {
    
  if (!customElements.get('c2s-cart-controller')) {
    customElements.define('c2s-cart-controller', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-cart-config]').textContent);
        this.giftIds = new Set(this.config.giftIds.map(Number));
        this.drawer = this.querySelector('[data-cart-dialog]');
        this.giftDialog = this.querySelector('[data-gift-dialog]');
        this.cartPage = document.querySelector('[data-cart-page]');
        this.onClick = this.handleClick.bind(this);
        this.onChange = this.handleChange.bind(this);
        this.onAdded = () => this.open();
        this.onKey = event => {
          if (event.key !== 'Enter') return;
          if (event.target.matches('[data-cart-code]')) {
            event.preventDefault();
            const code = event.target.value.trim();
            if (code && !this.busy) this.mutate('update', {discount:code}, {code});
          }
          if (event.target.matches('[data-cart-quantity]')) { event.preventDefault(); this.handleChange({target:event.target}); }
        };
        this.onSubmit = event => { if (this.busy && event.target.matches('[data-cart-form]')) event.preventDefault(); };
        document.addEventListener('click', this.onClick, true);
        document.addEventListener('change', this.onChange);
        document.addEventListener('c2s:cart-added', this.onAdded);
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('submit', this.onSubmit, true);
        const bridge = () => { if (window.shtCartDrawer) { window.shtCartDrawer.openDrawer = () => this.open(); window.shtCartDrawer.closeDrawer = () => this.drawer.close(); } };
        bridge();
        document.addEventListener('DOMContentLoaded', bridge, {once:true});
        [this.drawer, this.giftDialog].forEach(dialog => {
          dialog.addEventListener('close', () => {
            if (!this.drawer.open && !this.giftDialog.open) document.body.style.overflow = this.oldOverflow || '';
            if (dialog === this.giftDialog && this.drawer.open) this.drawer.querySelector('[data-view-offer]')?.focus();
            if (dialog === this.drawer && this.cartPage) {
              this.cartPage.hidden = false;
              let destination = new URL(this.cartPage.dataset.returnUrl || '/', location.origin);
              if (document.referrer) {
                const previous = new URL(document.referrer);
                if (previous.origin === location.origin && previous.pathname !== this.dataset.cartUrl && !previous.pathname.startsWith('/checkout')) destination = previous;
              }
              location.assign(destination);
            }
          });
          dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
        });
        if (this.dataset.hasGift === 'true') {
          this.busy = true;
          this.setBusy(true);
          this.currentTask = this.reload().catch(error => this.announce(error.message, true)).finally(() => { this.busy = false; this.setBusy(false); this.currentTask = null; });
        }
        if (this.cartPage) { this.cartPage.hidden = true; this.open(); }
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onClick, true);
        document.removeEventListener('change', this.onChange);
        document.removeEventListener('c2s:cart-added', this.onAdded);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('submit', this.onSubmit, true);
      }
      lockScroll() {
        if (!this.drawer.open && !this.giftDialog.open) this.oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      async open() {
        if (!this.drawer.open) { this.lockScroll(); this.drawer.showModal(); }
        try { if (this.currentTask) await this.currentTask; await this.reload(); } catch (error) { this.announce(error.message, true); }
      }
      async openGifts() {
        try {
          await this.reload();
          const template = this.querySelector('[data-gift-template]');
          this.querySelector('[data-gift-slot]').replaceChildren(template.content.cloneNode(true));
          if (!this.giftDialog.open) { this.lockScroll(); this.giftDialog.showModal(); }
        } catch (error) { this.announce(error.message, true); }
      }
      handleClick(event) {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = event.target.closest('a, button');
        if (!target) return;
        const nativeCartLink = target.matches('a[href]') && !target.hasAttribute('data-native-cart-page') && new URL(target.href, location.origin).pathname.replace(/\/$/,'') === this.dataset.cartUrl.replace(/\/$/,'');
        if (target.matches('[aria-controls="shtCartDrawer"], [data-cart-link]') || nativeCartLink) { event.preventDefault(); event.stopImmediatePropagation(); this.open(); return; }
        if (!target.closest('.c2s-cart-ui, .c2s-gift-dialog')) return;
        if (target.hasAttribute('data-cart-close')) { event.preventDefault(); this.drawer.close(); return; }
        if (target.hasAttribute('data-gift-close')) { event.preventDefault(); this.giftDialog.close(); return; }
        if (target.hasAttribute('data-view-offer')) { event.preventDefault(); this.openGifts(); return; }
        if (target.hasAttribute('data-cart-slide')) { const track = target.closest('.c2s-cart-ui__recommendations').querySelector('[data-cart-carousel]'); track.scrollBy({ left:Number(target.dataset.cartSlide) * track.clientWidth, behavior:'smooth' }); return; }
        if (this.busy || target.disabled) return;
        if (target.hasAttribute('data-cart-step')) { const line = target.closest('[data-cart-line]'); const input = line.querySelector('[data-cart-quantity]'); this.mutate('change', { id:line.dataset.cartLine, quantity:Math.max(0, Number(input.value) + Number(target.dataset.cartStep)) }); }
        if (target.hasAttribute('data-cart-remove')) this.mutate('change', { id:target.closest('[data-cart-line]').dataset.cartLine, quantity:0 });
        if (target.hasAttribute('data-cart-add')) this.mutate('add', { items:[{id:Number(target.dataset.cartAdd),quantity:1}] });
        if (target.hasAttribute('data-gift-add')) { const id = Number(target.closest('[data-gift-card]').querySelector('[data-gift-variant]')?.value || target.dataset.giftAdd); this.addGift(id); }
        if (target.hasAttribute('data-cart-apply')) { const code = target.closest('[data-discount-detail]').querySelector('[data-cart-code]').value.trim(); if (code) this.mutate('update', {discount:code}, {code}); }
      }
      handleChange(event) {
        const input = event.target;
        if (this.busy) return;
        if (input.matches('[data-cart-quantity]')) this.mutate('change', {id:input.closest('[data-cart-line]').dataset.cartLine, quantity:Math.max(0, Number(input.value) || 0)});
        if (input.matches('[data-cart-note]')) this.mutate('update', {note:input.value}, {note:true});
      }
      async request(action, body) {
        const response = await fetch(`${this.dataset.cartUrl}${action ? '/' + action : ''}.js`, body ? {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        let data;
        try { data = await response.json(); } catch { throw new Error(this.config.messages.error); }
        if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : this.config.messages.error);
        return data;
      }
      async normalizeGifts(cart, preferred) {
        const gifts = cart.items.filter(item => this.giftIds.has(Number(item.variant_id)));
        const keep = cart.total_price >= Number(this.dataset.threshold) ? (gifts.find(item => Number(item.variant_id) === preferred) || gifts[0]) : null;
        const updates = {};
        gifts.forEach(item => { const quantity = item === keep ? 1 : 0; if (item.quantity !== quantity) updates[item.key] = quantity; });
        if (Object.keys(updates).length) cart = await this.request('update', {updates});
        return cart;
      }
      async reload(preferred) {
        if (this.refreshing) return this.refreshing;
        this.refreshing = (async () => {
          this.cart = await this.normalizeGifts(await this.request(''), preferred);
          const url = new URL(location.href);
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {credentials:'same-origin',cache:'no-store'});
          if (!response.ok) throw new Error(this.config.messages.error);
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const config = doc.querySelector('[data-cart-config]');
          if (config) { this.config = JSON.parse(config.textContent); this.giftIds = new Set(this.config.giftIds.map(Number)); }
          const fresh = doc.querySelector('[data-cart-render]');
          if (!fresh) throw new Error(this.config.messages.error);
          document.querySelectorAll('[data-cart-render]').forEach(current => {
            const scroll = current.querySelector('[data-cart-scroll]').scrollTop;
            const discountOpen = current.querySelector('[data-discount-detail]')?.open;
            const noteOpen = current.querySelector('[data-note-detail]')?.open;
            const replacement = fresh.cloneNode(true);
            current.replaceWith(replacement);
            replacement.querySelector('[data-cart-scroll]').scrollTop = scroll;
            if (discountOpen && replacement.querySelector('[data-discount-detail]')) replacement.querySelector('[data-discount-detail]').open = true;
            if (noteOpen && replacement.querySelector('[data-note-detail]')) replacement.querySelector('[data-note-detail]').open = true;
          });
          const template = doc.querySelector('[data-gift-template]');
          if (template) { this.querySelector('[data-gift-template]').content.replaceChildren(template.content.cloneNode(true)); if (this.giftDialog.open) this.querySelector('[data-gift-slot]').replaceChildren(template.content.cloneNode(true)); }
          document.querySelectorAll('.js-cart-count-number, [data-cart-count]').forEach(counter => { counter.textContent = String(this.cart.item_count); });
          return this.cart;
        })().finally(() => { this.refreshing = null; });
        return this.refreshing;
      }
      setBusy(busy) {
        document.querySelectorAll('.c2s-cart-ui button, .c2s-cart-ui input, .c2s-cart-ui textarea, .c2s-gift-dialog button, .c2s-gift-dialog select').forEach(control => {
          if (control.matches('[data-cart-close], [data-gift-close]')) return;
          if (busy) { control.dataset.disabledBefore = String(control.disabled); control.disabled = true; }
          else if (control.hasAttribute('data-disabled-before')) { control.disabled = control.dataset.disabledBefore === 'true'; delete control.dataset.disabledBefore; }
        });
      }
      announce(message, error = false) { document.querySelectorAll('[data-cart-status], [data-gift-status]').forEach(status => { status.textContent = message; status.dataset.error = String(error); }); }
      mutate(action, body, options = {}) {
        if (this.busy) return this.currentTask;
        this.busy = true;
        this.setBusy(true);
        this.currentTask = (async () => {
          try {
            if (this.refreshing) await this.refreshing;
            await this.request(action, body);
            const cart = await this.reload(options.preferred);
            let message = options.note ? this.config.messages.noteSaved : options.preferred ? this.config.messages.giftAdded : this.config.messages.updated;
            if (options.code) {
              const applications = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))];
              const applied = applications.some(a => a.type === 'discount_code' && a.title.toLowerCase() === options.code.toLowerCase());
              message = applied ? this.config.messages.codeApplied : this.config.messages.codeInvalid;
            }
            this.announce(message);
            if (options.preferred && cart.items.some(item => Number(item.variant_id) === options.preferred)) this.giftDialog.close();
          } catch (error) { this.announce(error.message || this.config.messages.error, true); }
          finally { this.busy = false; this.setBusy(false); this.currentTask = null; }
        })();
        return this.currentTask;
      }
      addGift(id) {
        if (!this.giftIds.has(id) || !this.cart || this.cart.total_price < Number(this.dataset.threshold)) { this.announce(this.config.messages.giftLocked, true); return; }
        const existing = this.cart.items.find(item => Number(item.variant_id) === id);
        if (existing) { this.giftDialog.close(); return; }
        return this.mutate('add', {items:[{id,quantity:1,properties:{_c2s_gift:'true'}}]}, {preferred:id});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c2s-product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('c2s-product-page')) {
    customElements.define('c2s-product-page', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.messages = JSON.parse(this.querySelector('[data-product-messages]').textContent);
        this.addEventListener('click', (event) => {
          const option = event.target.closest('[data-option-value-id]');
          if (option && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
            event.preventDefault();
            this.changeOption(option);
          }
          const media = event.target.closest('[data-media-target]');
          if (media) this.showMedia(media.dataset.mediaTarget);
          if (event.target.closest('[data-bundle-add]')) this.addBundle();
        });
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-bundle-variant]')) this.updateBundleRow(event.target);
          if (event.target.matches('[data-bundle-variant], [data-bundle-check]')) this.updateBundleTotal();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === ' ' && event.target.matches('[data-option-value-id]')) {
            event.preventDefault();
            event.target.click();
          }
        });
        this.addEventListener('submit', (event) => {
          const form = event.target.closest('.c2s-pdp__form');
          if (!form) return;
          event.preventDefault();
          this.addSingle(form);
        });
        this.updateMainBundleRow();
        this.updateBundleTotal();
      }
      disconnectedCallback() {
        this.variantRequest?.abort();
      }
      currentVariant() {
        return JSON.parse(this.querySelector('[data-current-variant]').textContent);
      }
      showMedia(id) {
        this.querySelectorAll('[data-media-id]').forEach((item) => {
          item.hidden = item.dataset.mediaId !== id;
          if (item.hidden) item.querySelectorAll('video').forEach((video) => video.pause());
        });
        this.querySelectorAll('[data-media-target]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
      }
      async changeOption(option) {
        if (this.cartPending) return;
        if (option.dataset.optionProductUrl && new URL(option.dataset.optionProductUrl, location.origin).pathname !== location.pathname) {
          location.assign(option.href);
          return;
        }
        const group = option.closest('[data-option-position]');
        group.querySelectorAll('[data-option-value-id]').forEach((value) => {
          const selected = value === option;
          value.dataset.optionSelected = String(selected);
          value.setAttribute('aria-pressed', String(selected));
        });
        const ids = Array.from(this.querySelectorAll('[data-option-selected="true"]'), (value) => value.dataset.optionValueId);
        const url = new URL(location.href);
        url.searchParams.delete('variant');
        url.searchParams.set('option_values', ids.join(','));
        url.searchParams.set('section_id', this.dataset.sectionId);
        this.variantRequest?.abort();
        const controller = new AbortController();
        this.variantRequest = controller;
        this.variantPending = true;
        this.setPurchasePending(true);
        this.querySelector('[data-product-status]').textContent = this.messages.loading;
        try {
          const response = await fetch(url, { signal: AbortSignal.any([controller.signal, AbortSignal.timeout(15000)]) });
          if (!response.ok) throw new Error('Section request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (controller.signal.aborted) return;
          const updated = html.querySelector('c2s-product-page');
          if (!updated?.querySelector('[data-current-variant]')) throw new Error('Product section missing');
          const focusId = option.dataset.optionValueId;
          this.querySelector('[data-variant-panel]').replaceChildren(...updated.querySelector('[data-variant-panel]').childNodes);
          this.querySelector('[data-gallery]').replaceChildren(...updated.querySelector('[data-gallery]').childNodes);
          this.variantPending = false;
          this.setPurchasePending(false);
          this.updateMainBundleRow();
          this.updateBundleTotal();
          this.querySelector('[data-product-status]').textContent = '';
          const variant = this.currentVariant();
          url.searchParams.delete('section_id');
          if (variant.id) {
            url.searchParams.delete('option_values');
            url.searchParams.set('variant', variant.id);
          }
          history.replaceState({}, '', url);
          this.querySelector(`[data-option-value-id="${CSS.escape(focusId)}"]`)?.focus({ preventScroll: true });
          window.Shopify?.PaymentButton?.init();
        } catch (error) {
          if (error.name !== 'AbortError') {
            url.searchParams.delete('section_id');
            location.assign(url);
          }
        }
      }
      setPurchasePending(pending) {
        const available = this.currentVariant().available;
        const blocked = pending || this.cartPending || !available;
        this.querySelectorAll('[name="id"], [name="add"], [data-bundle-add], .shopify-payment-button button').forEach((button) => { button.disabled = blocked; });
        const checkout = this.querySelector('.shopify-payment-button');
        if (checkout) { checkout.inert = pending; checkout.style.pointerEvents = pending ? 'none' : ''; }
        this.querySelector('[data-variant-panel]').setAttribute('aria-busy', String(pending));
      }
      updateMainBundleRow() {
        const row = this.querySelector('[data-bundle-main]');
        if (!row) return;
        const variant = this.currentVariant();
        row.querySelector('[data-main-variant-title]').textContent = variant.title || '';
        row.querySelector('[data-main-variant-price]').textContent = variant.priceText || '';
        if (variant.image && row.querySelector('img')) {
          row.querySelector('img').removeAttribute('srcset');
          row.querySelector('img').src = variant.image;
        }
      }
      updateBundleRow(select) {
        const row = select.closest('[data-bundle-row]');
        const selected = select.selectedOptions[0];
        row.querySelector('[data-bundle-price]').textContent = selected.dataset.priceText;
        const image = row.querySelector('img');
        if (image && selected.dataset.image) {
          image.removeAttribute('srcset');
          image.src = selected.dataset.image;
        }
      }
      bundleItems() {
        const variant = this.currentVariant();
        if (!variant.id || !variant.available) return [];
        const items = [{ id: Number(variant.id), quantity: 1, price: variant.price }];
        this.querySelectorAll('[data-bundle-row]').forEach((row) => {
          if (!row.querySelector('[data-bundle-check]').checked) return;
          const option = row.querySelector('[data-bundle-variant]').selectedOptions[0];
          if (option && !option.disabled) items.push({ id: Number(option.value), quantity: 1, price: Number(option.dataset.price) });
        });
        return items;
      }
      updateBundleTotal() {
        const total = this.querySelector('[data-bundle-total]');
        if (!total) return;
        const amount = this.bundleItems().reduce((sum, item) => sum + item.price, 0);
        total.textContent = `— ${new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency }).format(amount / 100)}`;
      }
      addSingle(form) {
        if (this.variantPending || this.cartPending || !this.currentVariant().available) return;
        const fields = new FormData(form);
        const id = Number(fields.get('id'));
        const quantity = Number(fields.get('quantity') || 1);
        if (!Number.isSafeInteger(id) || id <= 0 || !Number.isInteger(quantity) || quantity <= 0) return;
        return this.addCartItems([{ id, quantity }], this.querySelector('[data-product-status]'));
      }
      addBundle() {
        if (this.variantPending || this.cartPending) return;
        const items = this.bundleItems();
        if (!items.length) return;
        return this.addCartItems(items.map(({ id, quantity }) => ({ id, quantity })), this.querySelector('[data-bundle-status]'));
      }
      async addCartItems(items, status) {
        if (this.variantPending || this.cartPending) return;
        this.cartPending = true;
        this.setPurchasePending(true);
        status.dataset.error = 'false';
        status.textContent = this.messages.adding;
        try {
          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            const error = new Error(typeof result.description === 'string' ? result.description : this.messages.cartError);
            error.fromCart = true;
            throw error;
          }
          status.textContent = this.messages.added;
          const cartUrl = new URL(this.dataset.cartUrl, location.origin);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) cartUrl.searchParams.set('preview_theme_id', preview);
          this.querySelectorAll('[data-cart-link]').forEach((link) => {
            link.href = cartUrl.href;
            link.hidden = false;
          });
          this.refreshCartCount();
          document.dispatchEvent(new CustomEvent('c2s:cart-added', {detail:{items}}));
        } catch (error) {
          status.dataset.error = 'true';
          status.textContent = error.fromCart ? error.message : this.messages.cartError;
        } finally {
          this.cartPending = false;
          this.setPurchasePending(Boolean(this.variantPending));
        }
      }
      async refreshCartCount() {
        try {
          const response = await fetch(`${this.dataset.cartUrl}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count)) return;
          document.querySelectorAll('.js-cart-count-number, [data-cart-count]').forEach((counter) => { counter.textContent = String(cart.item_count); });
        } catch {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
